import styled from '@emotion/styled';
import { ssColorDarkNavy } from '../constants/style-constants';
import { vunit } from '../lib/style-helpers';

const ScoreCardSection = styled.div`
  ${props => !props.bottomBorder && `
    border-bottom: 3px solid ${ssColorDarkNavy};
  `}
  margin: 0 -${vunit(4)};
  padding: 0 ${vunit(4)};

  & + & {
    margin-bottom: ${vunit(2)};
  }
`;

export default ScoreCardSection;
